export const ITEM_DEPARTMENT_CODES = {
  MAIN_KITCHEN: 2521,
  BEVERAGES: 2522,
};

export const ITEM_DEPARTMENT_NAMES = {
  MAIN_KITCHEN: "Main Kitchen (Hot Kitchen)",
  BEVERAGES: "Beverages",
};
